import { LanguageStringUploadDto } from "collaboration-service";
import { Flag, Icon } from "imaginarity-react-ui";
import _ from "lodash";
import React from "react";
import { PlaylistEditSequenceLinearSC as T } from "./PlaylistEditSequenceLinearSC";


interface PlaylistEditNodeTitleTooltipProps {
    data: LanguageStringUploadDto[];
    removeHtmlTags: (html: string) => string;
    hasEnGbTitleEntry: boolean;
    t: (key: string) => string;
    msg?: string;
}

const PlaylistEditNodeTitleTooltip: React.FC<PlaylistEditNodeTitleTooltipProps> = ({ data, removeHtmlTags, hasEnGbTitleEntry, t, msg }) => (
    <>
        <T.StyledHeadlineInfo>
            <Icon name="info" style={{ float: "left", marginRight: 10 }} marginTop={2} />
            {t("language variants")}
        </T.StyledHeadlineInfo>
        <T.StyledHeadlineInfoText>
            {msg ?? t("titles are translated into the languages listed. if a language lacks a title, english or the first entered language is used as a fallback.")}
        </T.StyledHeadlineInfoText>
        <T.StyledHeadlineGrid>
            {_.map(data, (n, j) => {
                const title = removeHtmlTags(n.text);
                const flag = <Flag hoverable={false} size={18} marginTop={0} name={n.lng as any} />;
                const isFallback = hasEnGbTitleEntry ? n.lng === "en-GB" : j === 0;
                return (
                    <React.Fragment key={j}>
                        {title !== undefined && title !== "" && (
                            <>
                                <T.TTFlag>{flag}</T.TTFlag>
                                <T.TTText style={{ fontWeight: isFallback ? "bolder" : "normal" }}>
                                    {isFallback && (
                                        <Icon name="arrow right" style={{ float: "left", marginRight: 5 }} marginTop={1} size={12} color="@accentBlack" />
                                    )}
                                    {title}
                                </T.TTText>
                            </>
                        )}
                    </React.Fragment>
                );
            })}
        </T.StyledHeadlineGrid>
    </>
);

export default PlaylistEditNodeTitleTooltip;
